"use strict";
// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var EllipsisOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 24 24", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "clip-rule": "evenodd", "d": "M5 10a2 2 0 100 4 2 2 0 000-4zM10 12a2 2 0 114 0 2 2 0 01-4 0zM17 12a2 2 0 114 0 2 2 0 01-4 0z", "fill-rule": "evenodd" } }] }, "name": "ellipsis", "theme": "outlined" };
exports.default = EllipsisOutlined;
